<a *ngIf="true" [href]="'https://app.appodeal.com' + currentHref" class="footer__own-dashboard txt-sm">{{
    'footer.links.ownDashboard' | i18next
}}</a>
